/* EndPageLabel.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "._80omtlke{cursor:pointer}";
const _10 = "._1wyb1j6v{font-size:1rem}";
const _9 = "._syaz14q2{color:var(--ds-link,#0c66e4)}";
const _8 = "._19bvidpf{padding-left:0}";
const _7 = "._n3tdidpf{padding-bottom:0}";
const _6 = "._u5f3idpf{padding-right:0}";
const _5 = "._ca0qidpf{padding-top:0}";
const _4 = "._19itglyw{border:none}";
const _3 = "._11q7glyw{background:none}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BodyNormal } from '@atlassian/mpac-primitives';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _2 = "._19pkoahv{margin-top:var(--ds-space-600,3pc)}";
const _ = "._y3gn1h6o{text-align:center}";
const Label = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_y3gn1h6o _19pkoahv", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Label.displayName = 'Label';
}
const BackToSearchButton = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6, _7, _8, _9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz14q2 _1wyb1j6v _80omtlke", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BackToSearchButton.displayName = 'BackToSearchButton';
}
const EndPageLabel = _ref3 => {
  let {
    onLinkClick
  } = _ref3;
  return /*#__PURE__*/_jsxs(Label, {
    children: ["Couldn\u2019t find what you were looking for? Try rephrasing", ' ', /*#__PURE__*/_jsx(BackToSearchButton, {
      onClick: onLinkClick,
      children: "your search query"
    }), "."]
  });
};
export default EndPageLabel;